export default "__VITE_ASSET__DPLEnIWS__"